module.exports = __webpack_public_path__ + "img/users-logo-signup-selection.78f6db4e.svg";